// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1NQWJ","content":"Consent_content__2PElc","footer":"Consent_footer__2ZQoj"};